import { useEffect, useState, useContext } from 'react'
import { useDispatch, useStore } from 'react-redux'

import HeaderComponent from '../../components/HeaderComponent'
import SideMenuComponent from '../../components/SideMenuComponent'
import BulkEditorPaneComponent from '../../components/AssignVendorComponent/modals/bulk-editor-pane'
import { getAllUsersInfo, getUsersByDomain } from '../../redux/actions/user'
import { createTwilioDevice } from '../../services/helper'
import InBoundCallComponent from '../../components/CommonComponents/InboundCallComponent'
import { END_INCOMING_CALL, INCOMING_CALL } from '../../redux/actionTypes/caller'
import { useWebSocketContext } from '../../websocketContext'
import { addCallDetails, matchInboundCaller, updateCallDetails } from '../../redux/actions/caller'
import { toast } from '../../components/CommonComponents/ToastComponent/toast'
import { WebSocketContext } from '../../hooks/useWebSocket';
import { AppContext } from '../../context'

const MainLayout = (props) => {
  const store = useStore().getState()
  const dispatch = useDispatch()
  const socketcon = useWebSocketContext();
  const { socketIo } = useContext(WebSocketContext)
  const { app, sideMenu, domain, auth: { user }, caller: { socketConnection, incomingCallReceived, inboundCall, incomingCall } } = store
  const { showBulkEditorPane } = app
  const { isSideMenuExpanded } = sideMenu
  const { currentDomain } = domain

  const {
    getNewUnreadNotification
  } = useContext(AppContext);

  const [isIncomingCall, setIsIncomingCall] = useState(false)
  const [isCallReceived, setIsCallReceived] = useState(false)
  const [call, setCall] = useState(null)
  const [incomingPhoneNo, setIncomingPhoneNo] = useState(null)
  const [callerId, setCallerId] = useState(null)
  const [matchData, setMatchData] = useState([])
  const [callDetails, setCallDetails] = useState({})
  const [callStatus, setCallStatus] = useState({})
  const [inboundNumber, setInboundNumber] = useState('')
  const [twilioDevice, setTwilioDevice] = useState(null)

  let path = window.location.href.split('lists')[1]
  // REJECT INCOMING CALL
  function rejectIncomingCall() {
    setIsCallReceived(false)
    setIsIncomingCall(false)
    setCall(null)
  }

  // HANG UP INCOMING CALL
  function hangupIncomingCall() {
    setIsCallReceived(false)
    setIsIncomingCall(false)
    setCall(null)
  }

  function acceptIncomingCall() {
    setIsCallReceived(true)
    setIsIncomingCall(false)
    setCall(null)
  }

  const handleEndCall = async (incomingRejectButton, incomingCallEndButton, callSid, duration) => {
    if (!incomingCallReceived && incomingRejectButton) {
      await incomingRejectButton.click()
    }
    if (incomingCallReceived && incomingCallEndButton) {
      await incomingCallEndButton.click()
    }
    dispatch({
      type: END_INCOMING_CALL
    })
    if (incomingCall) {
      dispatch(updateCallDetails({
        ...callDetails,
        endTime: new Date(),
        callDuration: duration
      }, callSid)).then(calldata => {
        setCallDetails({})
      }).catch((err) => {
        setCallDetails({})
      })
    }
  }

  const handleAddCallDetails = (statusUpdate, status) => {
    if (incomingCall) {
      const callDetails = {
        internalNumber: statusUpdate?.CalledVia,
        externalNumber: statusUpdate?.From,
        startTime: new Date(),
        callStatus: status,
        callType: 'inbound',
        callSid: statusUpdate?.ParentCallSid,
        externalNumberCity: statusUpdate?.FromCity,
        externalNumberState: statusUpdate?.FromState,
        externalNumberZip: statusUpdate?.FromZip,
        callerAssigned: user?.id,
        userId: user?.id
      }
      if (status === 'rejected' || status === 'no-answer') {
        callDetails.endTime = new Date()
        callDetails.callDuration = statusUpdate?.CallDuration
        dispatch({
          type: END_INCOMING_CALL
        })
      }
      setIsCallReceived(true)
      dispatch(addCallDetails(callDetails)).then(calldata => {
        setCallDetails(calldata)
      }).catch((err) => {
        setCallDetails({})
      })
    }
  }

  useEffect(() => {
    if (twilioDevice && user?.isCaller && user?.assignedPhoneNumber) {
      twilioDevice.on('incoming', async (call) => {
        dispatch({
          type: INCOMING_CALL,
          data: call
        })
        setIsIncomingCall(true)
        const phoneNo = call?.parameters?.From?.replaceAll(" ", "").slice(-10)
        const phoneNo1 = phoneNo?.replaceAll(" ", "").slice(0, -1)
        const phoneNo2 = phoneNo?.replaceAll(" ", "").slice(0, -2)
        const phoneNo3 = phoneNo?.replaceAll(" ", "").slice(0, -3)
        const phoneNumbers = [phoneNo, phoneNo1, phoneNo2, phoneNo3]
        await dispatch(matchInboundCaller(phoneNumbers)).then((res) => {
          setMatchData(res)
        }).catch(() => {
          setMatchData([])
        })
        setIncomingPhoneNo(call?.parameters?.From)
        setCallerId(call?.parameters?.CallSid)
        setCall(call)
      });

      twilioDevice.on('error', async (error) => {
        console.log("twilio error")
        toast.show({
          title: 'Warning',
          description: error.message,
        })
        if (error.message == "JWT Token Expired") {
          let newTwilioDevice = await createTwilioDevice(user, dispatch)
          setTwilioDevice(newTwilioDevice)
        }
      })
    }
  }, [twilioDevice])

  useEffect(() => {
    const createDevice = async () => {
      const device = await createTwilioDevice(user, dispatch)
      setTwilioDevice(device)
    }
    if (currentDomain?.id) {
      dispatch(getUsersByDomain(currentDomain?.id))
    }
    dispatch(getAllUsersInfo())
    createDevice()
  }, [])

  useEffect(() => {
    if (socketIo) {
      socketIo.on("callStatus", (callStatus) => {
        const statusUpdate = JSON?.parse(callStatus);
        setCallStatus(statusUpdate)
      });

      socketIo.on('inboundNumber', (number) => {
        setInboundNumber(number)
      })
    }
  }, [socketcon])

  useEffect(() => {
    if (callStatus) {
      const { CallStatus } = callStatus
      let incomingCallEndButton = document.getElementById('end-call')
      let incomingRejectButton = document.getElementById('reject-call')

      switch (CallStatus) {
        case 'initiated':
          console.log('main initiated', '\n\n')
          break;
        case 'ringing':
          console.log('main Ringing', '\n\n')
          break;
        case 'in-progress':
          handleAddCallDetails(callStatus, 'answered')
          // }
          console.log('main in-progress', '\n\n')
          break;
        case 'answered':
          console.log('main Answered', '\n\n')
          break;
        case 'completed':
          handleEndCall(incomingRejectButton, incomingCallEndButton, callStatus?.ParentCallSid, callStatus?.CallDuration)
          setIsIncomingCall(false)
          break;
        case 'busy':
          if (incomingRejectButton) {
            incomingRejectButton.click()
          }
          handleAddCallDetails(callStatus, 'rejected')
          getNewUnreadNotification()
          setIsIncomingCall(false)
          setIsCallReceived(false)
          break;
        case 'failed':
          if (incomingRejectButton) {
            incomingRejectButton.click()
          }
          if (incomingCallEndButton) {
            incomingCallEndButton.click()
          }
          setIsIncomingCall(false)
          setIsCallReceived(false)
          break;
        case 'no-answer':
          if (incomingRejectButton) {
            incomingRejectButton.click()
          }
          if (incomingCallEndButton) {
            incomingCallEndButton.click()
          }
          handleAddCallDetails(callStatus, 'no-answer')
          setIsIncomingCall(false)
          getNewUnreadNotification()
          break;
        case 'canceled':
          if (incomingRejectButton) {
            incomingRejectButton.click()
          }
          if (incomingCallEndButton) {
            incomingCallEndButton.click()
          }
          setIsIncomingCall(false)
          setIsCallReceived(false)
          break;
        default:
          break;
      }
    }
  }, [callStatus])

  return (
    <>
      <HeaderComponent />
      <SideMenuComponent />
      <div id='main-content' className={`main-content ${isSideMenuExpanded ? 'expanded' : ''}`}>
        {props.children}
        {showBulkEditorPane && <BulkEditorPaneComponent />}
        {(isIncomingCall) && (
          <InBoundCallComponent
            show={true}
            call={call}
            phoneNo={incomingPhoneNo}
            callerSID={callerId}
            onCallReject={rejectIncomingCall}
            onCallHangup={hangupIncomingCall}
            onAcceptCall={acceptIncomingCall}
            matchData={matchData}
          />
        )}
      </div>
    </>
  );
}

export default MainLayout
